/* Extra words that bring C1/C2 days up to 20. Keyed by level, then "id|title" (C1 days 7-10 share ids). */
export const VOCAB_MORE = {
 "C1": {
  "8|Gender, Feminism, and Intersectionality": [
   {
    "word": "gender mainstreaming",
    "ipa": "/ˈdʒendə ˈmeɪnstriːmɪŋ/",
    "arabic": "تعميم مراعاة المنظور الجنساني",
    "phonetic": "جيندر ميينستريمينغ",
    "example": "Gender mainstreaming requires governments to assess the effects of every policy on women and men before it is adopted.",
    "exampleAr": "يتطلب تعميم مراعاة المنظور الجنساني من الحكومات تقييم أثر كل سياسة على النساء والرجال قبل اعتمادها."
   }
  ],
  "11|Science, Technology, and Society": [
   {
    "word": "technological singularity",
    "ipa": "/ˌteknəˈlɒdʒɪkəl sɪŋɡjʊˈlærəti/",
    "arabic": "التفرد التكنولوجي",
    "phonetic": "تيكنولوجيكَل سينغيولاريتي",
    "example": "Some futurists predict that a technological singularity will occur once machines surpass human intelligence and begin improving themselves.",
    "exampleAr": "يتوقع بعض المستقبليين حدوث التفرد التكنولوجي عندما تتفوق الآلات على الذكاء البشري وتبدأ بتحسين نفسها."
   }
  ],
  "12|Media, Power, and Representation": [
   {
    "word": "media conglomerate",
    "ipa": "/ˈmiːdiə kənˈɡlɒmərət/",
    "arabic": "تكتل إعلامي",
    "phonetic": "ميديا كونغلوميرات",
    "example": "A single media conglomerate now owns newspapers, television channels and streaming platforms, raising concerns about diversity of opinion.",
    "exampleAr": "يمتلك تكتل إعلامي واحد الآن صحفاً وقنوات تلفزيونية ومنصات بث، مما يثير مخاوف بشأن تنوع الآراء."
   }
  ],
  "13|Urban Space, Architecture, and Power": [
   {
    "word": "urban regeneration",
    "ipa": "/ˈɜːbən rɪˌdʒenəˈreɪʃən/",
    "arabic": "التجديد الحضري",
    "phonetic": "اربن ريجينيريشن",
    "example": "Urban regeneration of the old docklands brought new housing, offices and public parks to a neglected district.",
    "exampleAr": "جلب التجديد الحضري لمنطقة الأرصفة القديمة مساكن ومكاتب وحدائق عامة إلى حي مهمل."
   },
   {
    "word": "zoning regulations",
    "ipa": "/ˈzəʊnɪŋ ˌreɡjʊˈleɪʃənz/",
    "arabic": "لوائح تقسيم المناطق",
    "phonetic": "زونينغ ريغيوليشنز",
    "example": "Strict zoning regulations limit the height of buildings and separate residential areas from industrial ones.",
    "exampleAr": "تحد لوائح تقسيم المناطق الصارمة من ارتفاع المباني وتفصل المناطق السكنية عن الصناعية."
   }
  ],
  "17|Religion, Secularism, and the Public Sphere": [
   {
    "word": "religious tolerance",
    "ipa": "/rɪˈlɪdʒəs ˈtɒlərəns/",
    "arabic": "التسامح الديني",
    "phonetic": "ريليجَس تولرَنس",
    "example": "Religious tolerance remains a cornerstone of stable and pluralistic societies.",
    "exampleAr": "يبقى التسامح الديني ركيزة أساسية للمجتمعات المستقرة والتعددية."
   }
  ],
  "18|Aesthetics, Art, and the Philosophy of Beauty": [
   {
    "word": "aesthetic judgement",
    "ipa": "/iːsˈθetɪk ˈdʒʌdʒmənt/",
    "arabic": "الحكم الجمالي",
    "phonetic": "إيس-ثيتيك جادجمنت",
    "example": "Kant argued that an aesthetic judgement claims universal agreement even though it rests on personal feeling.",
    "exampleAr": "رأى كانط أن الحكم الجمالي يدّعي إجماعاً عالمياً رغم أنه يستند إلى شعور شخصي."
   }
  ],
  "20|Migration, Borders, and Belonging": [
   {
    "word": "citizenship by naturalisation",
    "ipa": "/ˈsɪtɪzənʃɪp baɪ ˌnætʃrəlaɪˈzeɪʃən/",
    "arabic": "الحصول على الجنسية بالتجنس",
    "phonetic": "سيتيزنشيب باي ناتشرلايزيشن",
    "example": "Citizenship by naturalisation usually requires years of residence, language proficiency and a clean legal record.",
    "exampleAr": "يتطلب الحصول على الجنسية بالتجنس عادة سنوات من الإقامة وإتقان اللغة وسجلاً قانونياً نظيفاً."
   }
  ],
  "22|Democracy, Populism, and Political Crisis": [
   {
    "word": "separation of powers",
    "ipa": "/ˌsepəˈreɪʃən əv ˈpaʊəz/",
    "arabic": "الفصل بين السلطات",
    "phonetic": "سيبَريشن اوف باوَرز",
    "example": "The separation of powers prevents any single branch of government from acquiring unchecked authority.",
    "exampleAr": "يمنع الفصل بين السلطات أي فرع من فروع الحكومة من اكتساب سلطة بلا رقابة."
   }
  ],
  "23|International Relations and Global Order": [
   {
    "word": "balance of power",
    "ipa": "/ˈbæləns əv ˈpaʊə/",
    "arabic": "توازن القوى",
    "phonetic": "بالانس اوف باوَر",
    "example": "Many historians credit the balance of power among European states with preserving relative peace for decades.",
    "exampleAr": "ينسب كثير من المؤرخين إلى توازن القوى بين الدول الأوروبية الفضل في الحفاظ على سلام نسبي لعقود."
   }
  ],
  "33|Literature, Language, and Discourse": [
   {
    "word": "literary device",
    "ipa": "/ˈlɪtərəri dɪˈvaɪs/",
    "arabic": "أداة أدبية",
    "phonetic": "ليتَرَري ديفايس",
    "example": "Irony is a literary device that allows an author to suggest meanings opposite to the literal words.",
    "exampleAr": "السخرية أداة أدبية تتيح للكاتب الإيحاء بمعانٍ تعاكس الكلمات الحرفية."
   }
  ],
  "34|History, Memory, and the Politics of the Past": [
   {
    "word": "historical narrative",
    "ipa": "/hɪˈstɒrɪkəl ˈnærətɪv/",
    "arabic": "السرد التاريخي",
    "phonetic": "هيستوريكَل ناريتيف",
    "example": "Every historical narrative reflects choices about which events to include and which to leave out.",
    "exampleAr": "يعكس كل سرد تاريخي خيارات بشأن الأحداث التي تُدرج والتي تُهمل."
   }
  ]
 },
 "C2": {
  "6|Ethics, Moral Philosophy, and Practical Reason": [
   {
    "word": "supererogation",
    "ipa": "/ˌsuːpərˌɛrəˈɡeɪʃən/",
    "arabic": "العمل الزائد على الواجب",
    "phonetic": "سوبرإروجيْشن",
    "example": "Acts of supererogation, such as donating a kidney to a stranger, are praiseworthy but not strictly required by duty.",
    "exampleAr": "الأعمال الزائدة على الواجب، كالتبرع بكلية لغريب، محمودة لكنها ليست مفروضة بحكم الواجب."
   }
  ],
  "7|Language, Linguistics, and the Philosophy of Language": [
   {
    "word": "illocutionary force",
    "ipa": "/ˌɪləˈkjuːʃənri fɔːs/",
    "arabic": "القوة الإنجازية",
    "phonetic": "إللوكيوشنري فورس",
    "example": "The illocutionary force of the utterance was a warning, even though its grammatical form was that of a simple statement.",
    "exampleAr": "كانت القوة الإنجازية للعبارة تحذيراً، مع أن صيغتها النحوية كانت جملة خبرية بسيطة."
   }
  ],
  "8|History of Ideas, Intellectual Movements, and the Life of Concepts": [
   {
    "word": "historicism",
    "ipa": "/hɪˈstɒrɪsɪzəm/",
    "arabic": "المذهب التاريخي",
    "phonetic": "هيستورسيزم",
    "example": "Historicism holds that every idea must be understood within the particular context in which it arose.",
    "exampleAr": "يرى المذهب التاريخي أن كل فكرة يجب أن تُفهم ضمن السياق الخاص الذي نشأت فيه."
   }
  ],
  "11|Economics, Markets, and the Critique of Capitalism": [
   {
    "word": "path dependence",
    "ipa": "/pɑːθ dɪˈpɛndəns/",
    "arabic": "الاعتماد على المسار السابق",
    "phonetic": "باث ديبندنس",
    "example": "Path dependence explains why inefficient technical standards can persist long after better alternatives emerge.",
    "exampleAr": "يفسر الاعتماد على المسار السابق سبب استمرار المعايير التقنية غير الفعالة طويلاً بعد ظهور بدائل أفضل."
   }
  ],
  "12|Psychology, the Self, and the Complexities of Mental Life": [
   {
    "word": "confabulation",
    "ipa": "/kənˌfæbjʊˈleɪʃən/",
    "arabic": "اختلاق ذكريات",
    "phonetic": "كنفابيولَيشن",
    "example": "Patients with certain brain injuries engage in confabulation, sincerely recounting events that never occurred.",
    "exampleAr": "يمارس مرضى بعض إصابات الدماغ اختلاق الذكريات، فيروون بصدق أحداثاً لم تقع قط."
   }
  ],
  "13|Ecology, Climate Crisis, and Environmental Philosophy": [
   {
    "word": "planetary boundaries",
    "ipa": "/ˈplænɪtri ˈbaʊndriz/",
    "arabic": "الحدود الكوكبية",
    "phonetic": "بلانيتري باوندريز",
    "example": "The framework of planetary boundaries defines the safe operating space within which humanity can develop.",
    "exampleAr": "يحدد إطار الحدود الكوكبية المساحة الآمنة التي يمكن للبشرية أن تتطور ضمنها."
   }
  ],
  "14|Literature, Narrative, and the Meaning of Stories": [
   {
    "word": "metafiction",
    "ipa": "/ˈmɛtəˌfɪkʃən/",
    "arabic": "الأدب الميتاقصصي",
    "phonetic": "ميتافيكشن",
    "example": "Metafiction deliberately draws attention to its own status as an artefact, unsettling the reader.",
    "exampleAr": "يلفت الأدب الميتاقصصي الانتباه عمداً إلى كونه صنعة أدبية، فيزعزع طمأنينة القارئ."
   }
  ],
  "15|Sociology, Power, and the Structures of Social Life": [
   {
    "word": "reflexivity",
    "ipa": "/ˌriːflɛkˈsɪvəti/",
    "arabic": "الانعكاسية",
    "phonetic": "ريفلكسيفيتي",
    "example": "Reflexivity requires researchers to examine how their own position shapes the knowledge they produce.",
    "exampleAr": "تتطلب الانعكاسية من الباحثين أن يفحصوا كيف يشكل موقعهم الخاص المعرفة التي ينتجونها."
   },
   {
    "word": "structuration",
    "ipa": "/ˌstrʌktʃəˈreɪʃən/",
    "arabic": "نظرية التبنين",
    "phonetic": "ستركتشرَيشن",
    "example": "The theory of structuration argues that social structures are both produced and reproduced by human action.",
    "exampleAr": "تذهب نظرية التبنين إلى أن البنى الاجتماعية تُنتَج وتُعاد إنتاجها بالفعل البشري."
   }
  ],
  "16|Postcolonialism, Empire, and the Politics of Culture": [
   {
    "word": "neocolonialism",
    "ipa": "/ˌniːoʊkəˈloʊniəlɪzəm/",
    "arabic": "الاستعمار الجديد",
    "phonetic": "نيوكولونياليزم",
    "example": "Critics describe unequal debt arrangements as a form of neocolonialism that preserves old dependencies.",
    "exampleAr": "يصف النقاد ترتيبات الديون غير المتكافئة بأنها استعمار جديد يحافظ على التبعيات القديمة."
   },
   {
    "word": "epistemic violence",
    "ipa": "/ˌɛpɪˈstiːmɪk ˈvaɪələns/",
    "arabic": "العنف المعرفي",
    "phonetic": "إبيستيميك فايلنس",
    "example": "Spivak argues that silencing indigenous voices in scholarship constitutes epistemic violence.",
    "exampleAr": "ترى سبيفاك أن إسكات أصوات السكان الأصليين في الدراسات الأكاديمية يمثل عنفاً معرفياً."
   }
  ],
  "17|Media, Communication, and the Politics of Information": [
   {
    "word": "information asymmetry",
    "ipa": "/ˌɪnfərˈmeɪʃən eɪˈsɪmətri/",
    "arabic": "اللاتماثل المعلوماتي",
    "phonetic": "إنفورميشن أسيمتري",
    "example": "Information asymmetry between platforms and users allows opaque practices to flourish.",
    "exampleAr": "يتيح اللاتماثل المعلوماتي بين المنصات والمستخدمين ازدهار الممارسات الغامضة."
   }
  ],
  "18|Art, Aesthetics, and the Philosophy of Beauty": [
   {
    "word": "aesthetic distance",
    "ipa": "/iːsˈθɛtɪk ˈdɪstəns/",
    "arabic": "المسافة الجمالية",
    "phonetic": "إسثيتيك ديستنس",
    "example": "A degree of aesthetic distance allows us to enjoy a tragedy without being overwhelmed by its suffering.",
    "exampleAr": "تتيح لنا درجة من المسافة الجمالية الاستمتاع بالمأساة دون أن يغمرنا ألمها."
   }
  ],
  "19|Law, Justice, and the Nature of Rights": [
   {
    "word": "stare decisis",
    "ipa": "/ˌstɛəri dɪˈsaɪsɪs/",
    "arabic": "مبدأ السوابق القضائية",
    "phonetic": "ستاري ديسايسيس",
    "example": "The doctrine of stare decisis obliges courts to follow precedents established in earlier rulings.",
    "exampleAr": "يُلزم مبدأ السوابق القضائية المحاكم باتباع ما أُرسي في الأحكام السابقة."
   },
   {
    "word": "mens rea",
    "ipa": "/mɛnz ˈreɪə/",
    "arabic": "القصد الجنائي",
    "phonetic": "مينز ريا",
    "example": "Prosecutors must prove mens rea, meaning the accused acted with a guilty mind.",
    "exampleAr": "يجب على الادعاء إثبات القصد الجنائي، أي أن المتهم تصرف بنية إجرامية."
   }
  ],
  "20|Identity, Difference, and the Politics of Recognition": [
   {
    "word": "strategic essentialism",
    "ipa": "/strəˈtiːdʒɪk ɪˈsɛnʃəlɪzəm/",
    "arabic": "الجوهرانية الاستراتيجية",
    "phonetic": "ستراتيجيك إسينشاليزم",
    "example": "Minority movements sometimes adopt strategic essentialism, presenting a unified identity to secure political gains.",
    "exampleAr": "تتبنى حركات الأقليات أحياناً الجوهرانية الاستراتيجية فتقدم هوية موحدة لتحقيق مكاسب سياسية."
   }
  ],
  "21|Globalisation, Trade, and the World Economy": [
   {
    "word": "comparative institutional advantage",
    "ipa": "/kəmˈpærətɪv ˌɪnstɪˈtjuːʃənəl ədˈvɑːntɪdʒ/",
    "arabic": "الميزة المؤسسية النسبية",
    "phonetic": "كمبارتف إنستيتيوشنل أدفانتج",
    "example": "Scholars of varieties of capitalism stress comparative institutional advantage in explaining divergent national economies.",
    "exampleAr": "يؤكد دارسو أنماط الرأسمالية الميزة المؤسسية النسبية في تفسير تباين الاقتصادات الوطنية."
   },
   {
    "word": "capital flight",
    "ipa": "/ˈkæpɪtəl flaɪt/",
    "arabic": "هروب رؤوس الأموال",
    "phonetic": "كابيتال فلايت",
    "example": "Political instability triggered massive capital flight, which drained the central bank reserves.",
    "exampleAr": "تسبب عدم الاستقرار السياسي في هروب هائل لرؤوس الأموال استنزف احتياطيات البنك المركزي."
   }
  ],
  "22|Music, Sound, and the Aesthetics of Time": [
   {
    "word": "intertextuality in music",
    "ipa": "/ˌɪntərtɛkstʃuˈæləti ɪn ˈmjuːzɪk/",
    "arabic": "التناص الموسيقي",
    "phonetic": "إنترتيكستشوالِتي إن ميوزيك",
    "example": "Intertextuality in music appears when a composer quotes or transforms earlier works within a new piece.",
    "exampleAr": "يظهر التناص الموسيقي حين يقتبس المؤلف أعمالاً سابقة أو يحوّلها داخل قطعة جديدة."
   }
  ],
  "23|Memory, Trauma, and the Politics of the Past": [
   {
    "word": "collective amnesia",
    "ipa": "/kəˈlɛktɪv æmˈniːziə/",
    "arabic": "النسيان الجماعي",
    "phonetic": "كوليكتيف أمنيزيا",
    "example": "Collective amnesia allowed the atrocities to fade from public consciousness within a generation.",
    "exampleAr": "سمح النسيان الجماعي بأن تتلاشى الفظائع من الوعي العام خلال جيل واحد."
   },
   {
    "word": "commemoration",
    "ipa": "/kəˌmɛməˈreɪʃən/",
    "arabic": "إحياء الذكرى",
    "phonetic": "كوميموريشن",
    "example": "Annual commemoration of the massacre keeps the victims present in public life.",
    "exampleAr": "يُبقي إحياء الذكرى السنوي للمذبحة الضحايا حاضرين في الحياة العامة."
   }
  ],
  "24|Death, Mortality, and the Philosophy of Finitude": [
   {
    "word": "thanatology",
    "ipa": "/ˌθænəˈtɒlədʒi/",
    "arabic": "علم الموت",
    "phonetic": "ثاناتولَجي",
    "example": "Thanatology examines death, dying and bereavement from medical, psychological and cultural perspectives.",
    "exampleAr": "يدرس علم الموت الوفاة والاحتضار والثكل من منظورات طبية ونفسية وثقافية."
   }
  ],
  "25|Love, Friendship, and the Philosophy of Relationships": [
   {
    "word": "reciprocity",
    "ipa": "/ˌrɛsɪˈprɒsəti/",
    "arabic": "التبادلية",
    "phonetic": "ريسِبروسيتي",
    "example": "Many philosophers regard reciprocity as essential to genuine friendship, distinguishing it from mere patronage.",
    "exampleAr": "يرى كثير من الفلاسفة أن التبادلية جوهرية للصداقة الحقيقية وتميزها عن مجرد الرعاية."
   }
  ],
  "26|Work, Labour, and the Meaning of Human Activity": [
   {
    "word": "deskilling",
    "ipa": "/diːˈskɪlɪŋ/",
    "arabic": "تجريد العمل من المهارة",
    "phonetic": "ديسكيلينغ",
    "example": "Mechanisation led to the deskilling of many crafts, reducing artisans to machine operators.",
    "exampleAr": "أدت الميكنة إلى تجريد كثير من الحرف من المهارة، فصار الحرفيون مجرد مشغلي آلات."
   },
   {
    "word": "commodification of labour",
    "ipa": "/kəˌmɒdɪfɪˈkeɪʃən əv ˈleɪbər/",
    "arabic": "تسليع العمل",
    "phonetic": "كوموديفيكيشن أوف ليبر",
    "example": "The commodification of labour treats human effort as a product to be bought and sold.",
    "exampleAr": "يعامل تسليع العمل الجهد البشري كسلعة تُباع وتُشترى."
   }
  ],
  "27|Religion, Secularism, and the Sacred": [
   {
    "word": "apophatic theology",
    "ipa": "/ˌæpəˈfætɪk θiˈɒlədʒi/",
    "arabic": "اللاهوت السلبي",
    "phonetic": "أبوفاتيك ثيولَجي",
    "example": "Apophatic theology approaches the divine by stating what God is not rather than what God is.",
    "exampleAr": "يقترب اللاهوت السلبي من الإلهي بذكر ما ليس الله عليه لا ما هو عليه."
   },
   {
    "word": "disenchantment",
    "ipa": "/ˌdɪsɪnˈtʃɑːntmənt/",
    "arabic": "نزع السحر عن العالم",
    "phonetic": "ديسإنتشانتمنت",
    "example": "Weber described modernity as an age of disenchantment in which rational calculation displaces magic.",
    "exampleAr": "وصف ويبر الحداثة بأنها عصر نزع السحر عن العالم، حيث يحل الحساب العقلاني محل السحر."
   }
  ],
  "28|Democracy, Populism, and the Crisis of Liberal Order": [
   {
    "word": "illiberal democracy",
    "ipa": "/ɪˈlɪbərəl dɪˈmɒkrəsi/",
    "arabic": "الديمقراطية غير الليبرالية",
    "phonetic": "إليبرال ديموكراسي",
    "example": "Holding elections while curbing courts and the press produces an illiberal democracy.",
    "exampleAr": "إجراء الانتخابات مع تقييد القضاء والصحافة ينتج ديمقراطية غير ليبرالية."
   },
   {
    "word": "civil society",
    "ipa": "/ˈsɪvəl səˈsaɪəti/",
    "arabic": "المجتمع المدني",
    "phonetic": "سيفل سوسايتي",
    "example": "A vigorous civil society checks state power by organising citizens outside government.",
    "exampleAr": "يكبح المجتمع المدني النشط سلطة الدولة بتنظيم المواطنين خارج الحكومة."
   },
   {
    "word": "gerrymandering",
    "ipa": "/ˈdʒɛrimændərɪŋ/",
    "arabic": "التلاعب بحدود الدوائر الانتخابية",
    "phonetic": "جيريمانديرينغ",
    "example": "Gerrymandering distorts representation by drawing district boundaries to favour one party.",
    "exampleAr": "يشوّه التلاعب بحدود الدوائر التمثيل حين تُرسم لصالح حزب بعينه."
   }
  ],
  "29|Artificial Intelligence, Mind, and the Future of Humanity": [
   {
    "word": "the alignment problem",
    "ipa": "/ði əˈlaɪnmənt ˈprɒbləm/",
    "arabic": "مشكلة المواءمة",
    "phonetic": "ذي ألاينمنت بروبلم",
    "example": "The alignment problem asks how to ensure advanced systems pursue goals compatible with human values.",
    "exampleAr": "تسأل مشكلة المواءمة كيف نضمن أن تسعى الأنظمة المتقدمة إلى أهداف متوافقة مع القيم الإنسانية."
   },
   {
    "word": "emergent behaviour",
    "ipa": "/ɪˈmɜːdʒənt bɪˈheɪvjər/",
    "arabic": "السلوك الناشئ",
    "phonetic": "إميرجنت بيهيفيور",
    "example": "Large models display emergent behaviour that their designers neither planned nor fully predicted.",
    "exampleAr": "تُظهر النماذج الكبيرة سلوكاً ناشئاً لم يخطط له مصمموها ولم يتوقعوه بالكامل."
   }
  ]
 }
}
